export const DO_NOT_TRANSLATE_PREFIX = "DO_NOT_TRANSLATE/";
